import type { StepConfig, StepIds } from '~/components/premarketplace/partner-config';
import type { PartnerConfigStepFlow } from '~/gql/graphql';

const KNOWN_STEP_IDS: ReadonlySet<StepIds> = new Set([
  'introduction',
  'location',
  'categories',
  'household',
  'upgrade-profile',
  'financing-interest',
  'bundle-categories',
  'intent',
  'contact-time',
  'recommended-vendors',
  'contact',
]);

export const DEFAULT_STEP_FLOW: StepConfig[] = [
  { id: 'introduction', required: true },
  { id: 'location', required: true },
  { id: 'categories', required: true },
  { id: 'intent', required: true },
  { id: 'recommended-vendors', required: true },
  { id: 'contact', required: true },
];

export function parseStepFlow(raw: PartnerConfigStepFlow[] | null | undefined): StepConfig[] {
  if (!Array.isArray(raw) || raw.length === 0) return DEFAULT_STEP_FLOW;
  const valid = raw.filter(
    (s): s is { id: StepIds; required: boolean } =>
      typeof s?.id === 'string' && typeof s?.required === 'boolean' && KNOWN_STEP_IDS.has(s.id as StepIds),
  );
  if (valid.length === 0) return DEFAULT_STEP_FLOW;
  const mapped = valid.map(({ id, required }) => ({ id, required }));
  return mapped.some((s) => s.required) ? mapped : DEFAULT_STEP_FLOW;
}
